import React from 'react';
import { PlxsSpinner } from '@plexlogic/plexus-ui';

interface WizardSpinnerProps {
  size?: number;
  dataTestId?: string;
}

/**
 * WizardSpinner - A wrapper around PlxsSpinner for consistent loading states in wizard steps
 * 
 * @param size - Spinner size in pixels (default: 40)
 * @param dataTestId - Optional test identifier for testing
 */
const WizardSpinner: React.FC<WizardSpinnerProps> = ({
  size = 40,
  dataTestId = 'wizard-spinner',
}) => {
  return (
    <div
      data-testid={dataTestId}
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 'var(--plexus-space-lg)',
      }}
    >
      <PlxsSpinner size={size} />
    </div>
  );
};

export default WizardSpinner;
